import find from 'lodash/find';
import { SellingAccount } from '@models/account';

export const getSelectedSellingAccount = (
  sellingAccounts: SellingAccount[],
  selectedSellingAccountId: string,
) => {
  return find(sellingAccounts, {
    sellingAccountLinkToken: selectedSellingAccountId,
  });
};

/**
 * fix to standardize state names for compatibility with the address service and CLDR-Subdivisions package.
 */
export const getValidatedState = (stateName: string): string => {
  switch (stateName) {
    case 'Washington DC':
      return 'DC';
    default:
      return stateName;
  }
};
